import { render, staticRenderFns } from "./PasswordRecoveryMsgPanel.vue?vue&type=template&id=42f38c1c&scoped=true"
import script from "./PasswordRecoveryMsgPanel.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryMsgPanel.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecoveryMsgPanel.vue?vue&type=style&index=0&id=42f38c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f38c1c",
  null
  
)

export default component.exports